<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card shadow">
                <div class="card-body">
                    <div class="row">
                        <!-- Sidebar con tabs -->
                        <div class="col-lg-3 col-md-4">
                            <div class="profile-sidebar">
                                <!-- Mobile menu toggle -->
                                <button class="hamburger-menu d-md-none mb-3" (click)="toggleMenu()">
                                    <i class="fas fa-bars me-2"></i>
                                    <span>{{ nombreMenuSeleccionado }}</span>
                                </button>
                                
                                <!-- Sidebar Navigation Buttons -->
                                <div class="sidebar-nav" [class.mobile-hidden]="!menuAbierto">
                                    <button class="nav-btn" 
                                            [class.active]="selectedTab === 0"
                                            (click)="selectTab(0)">
                                        <i class="fas fa-user"></i>
                                        <span>Mi Perfil</span>
                                    </button>
                                    
                                    <button class="nav-btn" 
                                            [class.active]="selectedTab === 1"
                                            (click)="selectTab(1)">
                                        <i class="fas fa-graduation-cap"></i>
                                        <span>Mis Cursos</span>
                                    </button>
                                    
                                    <button class="nav-btn" 
                                            [class.active]="selectedTab === 2"
                                            (click)="selectTab(2)">
                                        <i class="fas fa-shopping-cart"></i>
                                        <span>Mis Compras</span>
                                    </button>
                                    
                                    <button class="nav-btn" 
                                            [class.active]="selectedTab === 3"
                                            (click)="selectTab(3)">
                                        <i class="fas fa-lock"></i>
                                        <span>Contraseña</span>
                                    </button>
                                </div>
                                
                                <!-- Logout button -->
                                <button class="btn btn-outline-danger w-100 mt-3" (click)="logOut()">
                                    <i class="fas fa-sign-out-alt me-2"></i>
                                    Cerrar Sesión
                                </button>
                            </div>
                        </div>
                        
                        <!-- Main content -->
                        <div class="col-lg-9 col-md-8">
                            <div class="profile-content">
                                
                                <!-- MI PERFIL TAB -->
                                <div *ngIf="selectedTab === 0" class="tab-content-section">
                                    <div class="section-header mb-4">
                                        <h4 class="section-title">Mi Perfil</h4>
                                        <p class="section-description">Gestiona tu información personal y configuración de cuenta</p>
                                    </div>
                                    
                                    <!-- Profile Image Card -->
                                    <div class="card mb-4">
                                        <div class="card-body text-center">
                                            <div class="profile-image-container">
                                                <img [src]="datosUsuario.profileFileUrl || 'assets/images/user.png'" 
                                                     alt="Imagen de perfil" 
                                                     class="profile-img">
                                                <button class="edit-img-btn" 
                                                        mat-fab 
                                                        (click)="triggerFileInput()"
                                                        matTooltip="Cambiar imagen">
                                                    <mat-icon>camera_alt</mat-icon>
                                                </button>
                                                <input type="file" 
                                                       #fileInput 
                                                       (change)="onFileSelected($event)" 
                                                       accept="image/*" 
                                                       hidden>
                                            </div>
                                            <h5 class="mt-3 mb-1">{{ datosUsuario.firstName }} {{ datosUsuario.lastName }}</h5>
                                            <p class="text-muted mb-0">{{ datosUsuario.email }}</p>
                                        </div>
                                    </div>
                                    
                                    <!-- Profile Form Card -->
                                    <div class="card">
                                        <div class="card-header d-flex justify-content-between align-items-center">
                                            <h6 class="mb-0">Información Personal</h6>
                                            <button class="btn btn-brand btn-sm" (click)="toggleEditMode()">
                                                <mat-icon class="me-1">{{ editMode ? 'save' : 'edit' }}</mat-icon>
                                                {{ editMode ? 'Guardar' : 'Editar' }}
                                            </button>
                                        </div>
                                        <div class="card-body">
                                            <form (ngSubmit)="onSubmit()" novalidate>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <mat-form-field appearance="outline" class="w-100 mb-3">
                                                            <mat-label>Nombre(s)</mat-label>
                                                            <input matInput 
                                                                   [(ngModel)]="datosUsuario.firstName" 
                                                                   name="firstName"
                                                                   [readonly]="!editMode"
                                                                   required>
                                                            <mat-icon matSuffix>person</mat-icon>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <mat-form-field appearance="outline" class="w-100 mb-3">
                                                            <mat-label>Apellido(s)</mat-label>
                                                            <input matInput 
                                                                   [(ngModel)]="datosUsuario.lastName" 
                                                                   name="lastName"
                                                                   [readonly]="!editMode"
                                                                   required>
                                                            <mat-icon matSuffix>person</mat-icon>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <mat-form-field appearance="outline" class="w-100 mb-3">
                                                            <mat-label>Correo Electrónico</mat-label>
                                                            <input matInput 
                                                                   [(ngModel)]="datosUsuario.email"
                                                                   name="email" 
                                                                   type="email"
                                                                   readonly>
                                                            <mat-icon matSuffix>email</mat-icon>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <mat-form-field appearance="outline" class="w-100 mb-3">
                                                            <mat-label>Teléfono</mat-label>
                                                            <input matInput 
                                                                   [(ngModel)]="datosUsuario.phoneNumber" 
                                                                   name="phoneNumber"
                                                                   [readonly]="!editMode">
                                                            <mat-icon matSuffix>phone</mat-icon>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-12">
                                                        <mat-form-field appearance="outline" class="w-100 mb-3">
                                                            <mat-label>Biografía</mat-label>
                                                            <textarea matInput 
                                                                      [(ngModel)]="datosUsuario.biography" 
                                                                      name="biography"
                                                                      [readonly]="!editMode"
                                                                      rows="4"
                                                                      placeholder="Cuéntanos sobre ti...">
                                                            </textarea>
                                                            <mat-icon matSuffix>description</mat-icon>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- MIS CURSOS TAB -->
                                <div *ngIf="selectedTab === 1" class="tab-content-section">
                                    <div class="section-header mb-4">
                                        <h4 class="section-title">Mis Cursos</h4>
                                        <p class="section-description">Visualiza y gestiona tus cursos inscritos</p>
                                    </div>
                                    
                                    <div class="card">
                                        <div class="card-body text-center py-5">
                                            <mat-icon class="display-1 text-muted mb-3">school</mat-icon>
                                            <h6 class="text-muted">No tienes cursos inscritos</h6>
                                            <p class="text-muted">Cuando te inscribas a cursos, aparecerán aquí</p>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- MIS COMPRAS TAB -->
                                <div *ngIf="selectedTab === 2" class="tab-content-section">
                                    <div class="section-header mb-4">
                                        <h4 class="section-title">Mis Compras</h4>
                                        <p class="section-description">Historial de tus transacciones y compras</p>
                                    </div>
                                    
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table class="table table-hover">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th>Folio</th>
                                                            <th>Fecha</th>
                                                            <th>Descripción</th>
                                                            <th>Total</th>
                                                            <th>Estado</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let order of pagedOrders">
                                                            <td><strong>#{{ order.id }}</strong></td>
                                                            <td>{{ order.SaleOrderDate | date: 'dd/MM/yyyy' }}</td>
                                                            <td>{{ order.PurchaseDescription }}</td>
                                                            <td><strong>{{ order.SubtotalAmount | currency:'USD' }}</strong></td>
                                                            <td>
                                                                <span class="badge bg-success">{{ order.SaleOrderStatus }}</span>
                                                            </td>
                                                        </tr>
                                                        <tr *ngIf="!pagedOrders?.length">
                                                            <td colspan="5" class="text-center py-4">
                                                                <mat-icon class="display-4 text-muted mb-2">shopping_cart</mat-icon>
                                                                <p class="text-muted mb-0">No hay compras registradas</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            
                                            <!-- Pagination -->
                                            <nav *ngIf="pagedOrders?.length" class="d-flex justify-content-center mt-3">
                                                <ul class="pagination">
                                                    <li class="page-item" [class.disabled]="pagina === 1">
                                                        <a class="page-link" (click)="paginarCompras('resta')">
                                                            <mat-icon>chevron_left</mat-icon>
                                                        </a>
                                                    </li>
                                                    <li class="page-item active">
                                                        <span class="page-link">{{ pagina }}</span>
                                                    </li>
                                                    <li class="page-item" [class.disabled]="pagina === totalPages">
                                                        <a class="page-link" (click)="paginarCompras('suma')">
                                                            <mat-icon>chevron_right</mat-icon>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- CONTRASEÑA TAB -->
                                <div *ngIf="selectedTab === 3" class="tab-content-section">
                                    <div class="section-header mb-4">
                                        <h4 class="section-title">Actualizar Contraseña</h4>
                                        <p class="section-description">Solicita un enlace para restablecer tu contraseña</p>
                                    </div>
                                    
                                    <div class="card">
                                        <div class="card-body">
                                            <form [formGroup]="passwordForm" (ngSubmit)="sendResetPassword()">
                                                <div class="row justify-content-center">
                                                    <div class="col-md-6">
                                                        <mat-form-field appearance="outline" class="w-100 mb-3">
                                                            <mat-label>Correo Electrónico</mat-label>
                                                            <input matInput 
                                                                   formControlName="email" 
                                                                   type="email"
                                                                   placeholder="Ingresa tu correo electrónico">
                                                            <mat-icon matSuffix>email</mat-icon>
                                                            <mat-error *ngIf="passwordForm.get('email')?.hasError('required')">
                                                                El correo es requerido
                                                            </mat-error>
                                                            <mat-error *ngIf="passwordForm.get('email')?.hasError('email')">
                                                                Ingresa un correo válido
                                                            </mat-error>
                                                        </mat-form-field>
                                                        
                                                        <div class="d-grid">
                                                            <button type="submit" 
                                                                    class="btn btn-brand btn-lg"
                                                                    [disabled]="passwordForm.invalid">
                                                                <mat-icon class="me-2">send</mat-icon>
                                                                Enviar Enlace de Restablecimiento
                                                            </button>
                                                        </div>
                                                        
                                                        <div class="alert alert-info mt-3">
                                                            <mat-icon class="me-2">info</mat-icon>
                                                            Te enviaremos un correo con las instrucciones para restablecer tu contraseña.
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
